export function resolveExtractPollPayload(status) {
  const extractJob = status?.extractJob || status?.quickCashflow?.extractJob;
  const qcf = status?.quickCashflow;
  return { extractJob, qcf };
}

export function isExtractJobComplete(status) {
  return status === 'complete' || status === 'completed';
}

/** Merge top-level extractJob status into assistSession after poll complete/failed. */
export function applyExtractPollTerminal(prev, qcf, extractJob) {
  const next = { ...prev };
  if (qcf?.assistSession) {
    next.assistSession = qcf.assistSession;
  }
  if (qcf?.accountingSnapshot) {
    next.accountingSnapshot = qcf.accountingSnapshot;
  }
  if (!extractJob) {
    return next;
  }
  next.assistSession = {
    ...(qcf?.assistSession || next.assistSession || prev.assistSession || {}),
    extractJob,
  };
  if (isExtractJobComplete(extractJob.status)) {
    next.assistSession.phase = qcf?.stage || next.assistSession.phase || 'done';
  }
  return next;
}
